import { createFileRoute } from '@tanstack/react-router'
import { BACKLINK_CHANGE_DAYS } from '@/lib/backlinks'
import { DomainFacet } from '../-facet'

export const Route = createFileRoute('/_app/$org/$host/backlinks/_list/lost')({
  component: LostPage,
})

/** The domains that have stopped being seen linking here. */
function LostPage() {
  return (
    <DomainFacet
      title={`Lost in the last ${BACKLINK_CHANGE_DAYS} days`}
      status="lost"
      emptyLabel={`No linking domain has gone in the last ${BACKLINK_CHANGE_DAYS} days.`}
    />
  )
}
